import { useAccountStore } from "@/modules/account/store"
import { watch } from "vue"
import { useAppConfigStore } from "@/store/appConfig"
import { initSentry, setUserInSentry } from "@/logic/sentry"
import { Vue } from "@sentry/vue/build/types/types"
import { loadScript } from "@/logic/loadScript"

export const initHubspot = (app: Vue) => {
  loadScript(import.meta.env.VITE_HUBSPOT_TRACKING)

  const accountStore = useAccountStore()
  const appConfigStore = useAppConfigStore()

  window.hsConversationsSettings = {
    loadImmediately: false,
  }

  function onConversationsAPIReady() {
    watch([() => accountStore.hubspotVisitorToken, () => appConfigStore.settings], () => loadWidget(), { immediate: true })
  }

  if (window.HubSpotConversations) {
    onConversationsAPIReady()
  } else {
    window.hsConversationsOnReady = [onConversationsAPIReady]
  }

  const loadWidget = async () => {
    if (!accountStore.isLoggedIn) {
      removeHubspot()
      return
    }
    const status = window.HubSpotConversations?.widget.status()
    if (status?.loaded) {
      return
    }
    if (!Object.keys(appConfigStore.settings).length) {
      return
    }
    if (appConfigStore.settings.hide_intercom_chat) {
      initSentry(app)
      if (accountStore.isLoggedIn) {
        setUserInSentry(accountStore.id!)
      }
      return
    }
    const visitorToken = await accountStore.getHubspotVisitorToken()

    if (!visitorToken) {
      return
    }

    window.hsConversationsSettings = {
      identificationEmail: accountStore.email,
      identificationToken: visitorToken,
    }

    window.HubSpotConversations?.widget.load()
    window.HubSpotConversations?.on("widgetLoaded", () => {
      initSentry(app)
      if (accountStore.isLoggedIn) {
        setUserInSentry(accountStore.id!)
      }
    })
  }
}

export const removeHubspot = () => {
  window.HubSpotConversations?.widget.remove()
}
